<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
      <h4>Mes Activités</h4>
      <!-- <p>
       Lorem ipsum
      </p> -->
    </div>
    <div class="col-12 form-group">
        <label for="prenom"><strong>Choisis les activités qui t'intéressent : </strong></label><br/><br/>
        <div class="row">
            <div class="col-12 col-md-6 col-xxl-3" *ngFor="let item of petitssalons">
                <div class="card" >
                    <!-- <img src="..." class="card-img-top" alt="..."> -->
                    <div class="card-body">
                      <h5 class="card-title" [ngClass]="item.type">{{item.title}}</h5>
                      <p class="card-text smallDescription" style="white-space:pre-wrap;">{{item.smallDescription}}</p>
                      <p class="card-text description" style="white-space:pre-wrap;">{{item.description}}</p>
                      <button class="btn" (click)="selectItem(item)" *ngIf="!isSelectedItem(item)">Choisir</button>
                      <button class="btn btn-success" (click)="unselectItem(item)" *ngIf="isSelectedItem(item)">Choisi <i class="fa fa-check"></i></button>

                      <div class="bg-light p-15" *ngIf="isSelectedItem(item) && item.type == 'petitsalon_rdv'">

                        <div class="col-12 form-group">
                            <label for="adresseAlt">Quel professionnel voulez-vous rencontrer?</label>
                            <dx-select-box
                              [items]="listPro"
                              [(value)]="inscriptionService.form.salons.petitsalon_rdv.selection"
                              placeholder="Choisissez un professionnel"
                              [showClearButton]="true"
                              [elementAttr]="{
                                id: 'selection',
                                class:
                                  ' form-control ' + (formCheck.selection?.hasError ? 'is-invalid' : '')
                              }"
                              (onValueChanged)="checkCanNextStep()"
                            ></dx-select-box>
                            <div id="selection-error" class="is-invalid" *ngIf="formCheck.selection?.hasError">{{ formCheck.selection.message}}</div>
                            <!-- <input type="text" value="" class=" form-control" data-dashlane-rid="1a9e9bf8171efd80" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-4" data-inscriptionService.form.user-type="address,extra"> -->
                          </div>
                          <div class="col-12 form-group">
                            <label for="adresseAlt">Pourquoi souhaitez-vous le rencontrer?</label>
                            <dx-text-box
                              [(value)]="inscriptionService.form.salons.petitsalon_rdv.commentaire"
                              placeholder=""
                              [elementAttr]="{
                                id: 'commentaire',
                                class:
                                  ' form-control ' + (formCheck.commentaire?.hasError ? 'is-invalid' : '')
                              }"
                              (onValueChanged)="checkCanNextStep()"
                            ></dx-text-box>
                            <div id="commentaire-error" class="is-invalid" *ngIf="formCheck.commentaire?.hasError">{{ formCheck.commentaire.message}}</div>
                            <!-- <input type="text" value="" class=" form-control" data-dashlane-rid="1a9e9bf8171efd80" data-kwimpalastatus="alive" data-kwimpalaid="1654450318279-4" data-inscriptionService.form.user-type="address,extra"> -->
                          </div>
                    </div>
                    <div class="moreChoices bg-light p-15 text-sm" *ngIf="isSelectedItem(item) && item.childrens?.length">
                        <div class="col-12 form-group">
                            <p>Choisis une ou plusieurs activités</p>
                            <ul class="p-0">
                              <li *ngFor="let subitem of item.childrens; let i = index">
                                <div class="subtitle" *ngIf="subitem.smallDescription != item.childrens[i-1]?.smallDescription">{{subitem.smallDescription}}</div>
                                {{subitem.title}}
                                <button class="btn btn-sm" (click)="selectItem(subitem)" *ngIf="!isSelectedItem(subitem)">Choisir</button>
                                <button class="btn btn-success btn-sm" (click)="unselectItem(subitem)" *ngIf="isSelectedItem(subitem)">Choisi <i class="fa fa-check"></i></button>

                              </li>
                            </ul>

                            <div id="offres-error" class="is-invalid" *ngIf="formCheck.activites[item.id]?.hasError">{{ formCheck.activites[item.id].message}}</div>

                          </div>
                    </div>
                    <div class="moreChoices bg-light p-15" *ngIf="isSelectedItem(item) && item.type == 'petitsalon_offres'">
                        <div class="col-12 form-group">
                            <p>Choisissez une offre</p>
                            <button class="btn" (click)="toggleOffres()">Choisir une offre <i class="fa fa-eye"></i></button>
                            <div id="offres-error" class="is-invalid" *ngIf="formCheck.offres?.hasError">{{ formCheck.offres.message}}</div>

                          </div>
                          <div class="col-12">
                              <p><strong *ngIf="inscriptionService.form.offres.selectedItems.length">Selection :</strong></p>
                              <div class="offres" *ngFor="let item of inscriptionService.form.offres.selectedItems">
                                 <i class="fa fa-home"></i> {{ item.title }}
                              </div>
                            </div>
                    </div>
                    </div>
                  </div>
            </div>
        </div>

        </div>
  </div>
</div>

<div class="modal-footer">

    <div *ngIf="currentUser">
      <div class="">
        connecté en tant que {{ currentUser.prenom }} {{ currentUser.nom }} / {{ currentUser.email }}
        <i class="fa fa-user"></i>
      </div>
    </div>
    <button class="btn btn-danger btn-b" type="button" (click)="close()" *ngIf="inscriptionService.form.step <= 1">
      annuler
    </button>
    <button class="btn btn-danger btn-b" type="button" (click)="prevStep()" *ngIf="inscriptionService.form.step >  1">
     retour
    </button>
    <button class="btn btn-b" [class.btn-success]="canNextStep" type="button" (click)="nextStep()">Continuer <i class="fa fa-warning" *ngIf="!canNextStep"></i></button>
  </div>

<div
class="modal fade show d-block"
id="modalInscription"
*ngIf="offresVisible"
>
<div class="bg-overlay"></div>
<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <app-cllajoffres (onClose)="toggleOffres()"></app-cllajoffres>
  </div>
</div>
</div>
